import { useState } from 'react'
import { Radio } from 'antd'
import { AnnotationType } from 'types/building'

import ImageAnnotationIcon from 'components/icons/ImageAnnotationIcon'
import InfoAnnotationIcon from 'components/icons/InfoAnnotationIcon'
import MovieAnnotationIcon from 'components/icons/MovieAnnotationIcon'

import CustomRadioCard from './CustomRadioCard'

type Props = {
  selectedFolder: AnnotationType
  changeSelectedFolder: (value: any) => void
}

const annotationOptions = [
  {
    value: 120,
    label: 'ピクチャ',
    icon: <ImageAnnotationIcon />
  },
  {
    value: 130,
    label: 'ムービー',
    icon: <MovieAnnotationIcon />
  },
  {
    value: 140,
    label: 'インフォ',
    icon: <InfoAnnotationIcon />
  }
]

export default function TourAnnotationTypeSelector({
  selectedFolder,
  changeSelectedFolder
}: Props) {
  const [selected, setSelected] = useState(selectedFolder)
  const changeSelected = (value: any) => {
    setSelected(value)
    changeSelectedFolder(value)
  }
  return (
    <div className="flex items-center justify-center mb-[5px]">
      <Radio.Group
        value={selected}
        onChange={(e) => changeSelected(e.target.value)}
        className="flex justify-center "
      >
        {annotationOptions.map((option) => (
          <CustomRadioCard
            key={option.value}
            value={option.value}
            label={option.label}
            icon={option.icon}
            checked={selected === option.value}
          />
        ))}
      </Radio.Group>
    </div>
  )
}
